module.exports = __webpack_public_path__ + "static/media/ss_3_jp.184e5fd2.jpg";